<template>
    <div class="iframe-container">
        <div v-if="errorMsg" class="error">
            {{ errorMsg }}
        </div>
        <iframe
            v-else
            class="iframe"
            v-bind:src="iframeUrl"
            allow="fullscreen"
            height="100%"
            width="100%"
        />
    </div>
</template>

<script lang="ts">
    import { useScriptTag } from '@vueuse/core';
    import { defineComponent, ref } from 'vue';
    import { LiveStreamResource } from '@/interface/enum';
    import Api from '@/libraries/api';

    export default defineComponent({
        name: 'GLiveStream',
        props: {
            matchId: {
                type: Number,
                required: true,
            },
        },
        setup(props) {
            useScriptTag('https://gls.liveplugins.com/embed.js', () => {}, { attrs: { 'data-site-id': 'gls' } });

            const iframeUrl = ref('');
            const errorMsg = ref('');

            async function fetchLiveStream() {
                try {
                    const { url, errorCode, errorMessage } = await Api.getLiveStream(props.matchId, LiveStreamResource.GLive);
                    if (errorCode === 0 && url) {
                        iframeUrl.value = `${url}&compact=1`;
                    } else if (errorMessage) {
                        errorMsg.value = errorMessage;
                    }
                } catch (error: any) {
                    errorMsg.value = error.toString();
                }
            }

            fetchLiveStream();

            return {
                iframeUrl,
                errorMsg,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/gLiveStream";
</style>
